import { useState, useEffect } from 'react'
import type { WidgetModuleV2, WidgetModuleV3 } from './types'

type MagicLinkWidgetVersion = 'v2' | 'v3'

type WidgetLoaderState = {
  widgetModuleV3: WidgetModuleV3 | null
  widgetModuleV2: WidgetModuleV2 | null
  moduleError: string | null
}

export function useWidgetLoader(
  magicLinkWidgetVersion: MagicLinkWidgetVersion,
  preferencesLoading: boolean
) {
  const [state, setState] = useState<WidgetLoaderState>({
    widgetModuleV3: null,
    widgetModuleV2: null,
    moduleError: null,
  })

  useEffect(() => {
    let cancelled = false

    const loadWidget = async () => {
      if (preferencesLoading) return

      setState({ widgetModuleV3: null, widgetModuleV2: null, moduleError: null })

      try {
        if (magicLinkWidgetVersion === 'v3') {
          const mod = await import('@hotglue/widget')
          if (!cancelled) {
            setState((s) => ({ ...s, widgetModuleV3: mod as unknown as WidgetModuleV3 }))
            try {
              await import('@hotglue/widget/dist/widget-react.css')
            } catch {
              // v3 css may already be loaded from main or bundled
            }
          }
        } else {
          const mod = await import('widget-v2')
          if (!cancelled) {
            setState((s) => ({ ...s, widgetModuleV2: mod as unknown as WidgetModuleV2 }))
          }
        }
      } catch (err) {
        if (!cancelled) {
          setState((s) => ({
            ...s,
            moduleError: err instanceof Error ? err.message : String(err),
          }))
        }
      }
    }

    loadWidget()
    return () => {
      cancelled = true
    }
  }, [magicLinkWidgetVersion, preferencesLoading])

  return state
}
